// frontend/src/component/HomePromoGrid.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import banner1 from "./Image/promoimage.png";
import banner2 from "./Image/banner2.png";
import banner3 from "./Image/banner3.png";

/**
 * Данные промо. Для любого баннера можно задать overlay-текст (title/subtitle),
 * который показывается поверх карточки (не обрежется).
 */
const promos = [
  {
    src: banner1,
    alt: "Промокод ВЕСНА25 — скидка 5%",
    href: "/price", // при необходимости измени ссылку
  },
  {
    src: banner2,
    alt: "Гидрогелевая плёнка",
    href: "/price?q=гидрогелевая%20плёнка",
  },
  {
    src: banner3,
    alt: "Подарок при покупке смартфона",
    href: "/price?q=смартфон",
  },
];

/** Карточка промо с «умным» вписыванием изображения */
function PromoCard({ p, height }) {
  return (
    <a
      href={p.href}
      className="relative overflow-hidden rounded-xl bg-white shadow-md block"
      aria-label={p.alt}
    >
      {/* фиктивная высота: единая для всех карточек */}
      <div style={{ height }} />

      {/* Фон: заполняет всю карточку (cover) и размыт — чтобы не было «пустот» */}
      <img
        src={p.src}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full"
        style={{ objectFit: "cover", filter: "blur(12px)", transform: "scale(1.06)", opacity: 0.75 }}
      />

      {/* Основное изображение: целиком видно (contain), без обрезки текста */}
      <img
        src={p.src}
        alt={p.alt}
        className="absolute inset-0 h-full w-full"
        style={{ objectFit: "contain" }}
      />

      {/* Оверлей с текстом промо-кода (если задан) */}
      {(p.title || p.subtitle) && (
        <div className="absolute left-3 top-3 right-3 max-w-[80%]">
          <div className="inline-flex flex-col gap-1 rounded-lg bg-black/45 px-3 py-2 backdrop-blur-sm">
            {p.title && (
              <div className="text-white font-extrabold leading-tight text-lg sm:text-xl">
                {p.title}
              </div>
            )}
            {p.subtitle && (
              <div className="text-white/90 text-xs sm:text-sm leading-snug">
                {p.subtitle}
              </div>
            )}
          </div>
        </div>
      )}
    </a>
  );
}

export default function HomePromoGrid() {
  return (
    <section className="w-full mt-6">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-2xl font-bold mb-4">Акции и предложения</h2>

        {/* Мобайл: свайпер по 1 баннеру */}
        <div className="sm:hidden">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={12}
            slidesPerView={1}
            className="rounded-xl"
          >
            {promos.map((p, i) => (
              <SwiperSlide key={i}>
                <PromoCard p={p} height={"clamp(140px, 35vw, 220px)"} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Десктоп/планшет: сетка 3 */}
        <div className="hidden sm:grid grid-cols-3 gap-3">
          {promos.map((p, i) => (
            <PromoCard key={i} p={p} height={"clamp(160px, 18vw, 220px)"} />
          ))}
        </div>
      </div>
    </section>
  );
}
